/**
 * @generated SignedSource<<81821290a6c33f4a66daa699312c4760>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Roles = "ADMIN" | "COWORKER_GROUP" | "CO_WORKER" | "MANAGER" | "READ_ONLY";
import { FragmentRefs } from "relay-runtime";
export type UserAdminEmployees_store$data = {
  readonly employees: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly storeUser: {
          readonly id: string;
          readonly role: Roles;
          readonly user: {
            readonly email: string;
            readonly id: string;
          };
          readonly " $fragmentSpreads": FragmentRefs<"StoreUserRoleAndEmailTag_storeUser">;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
      };
    }>;
  };
  readonly hasEmployeeProvider: boolean;
  readonly id: string;
  readonly " $fragmentType": "UserAdminEmployees_store";
};
export type UserAdminEmployees_store$key = {
  readonly " $data"?: UserAdminEmployees_store$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserAdminEmployees_store">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserAdminEmployees_store",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasEmployeeProvider",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "NAME"
        }
      ],
      "concreteType": "EmployeeConnection",
      "kind": "LinkedField",
      "name": "employees",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Employee",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Avatar_employee"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "StoreUser",
                  "kind": "LinkedField",
                  "name": "storeUser",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "StoreUserRoleAndEmailTag_storeUser"
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "email",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "role",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "employees(orderBy:\"NAME\")"
    }
  ],
  "type": "Store",
  "abstractKey": null
};
})();

(node as any).hash = "6e8aef3f2d72620db1831325dc29fd55";

export default node;
